import { QcDialog } from '@tencent/qcvue2';

const dialog = {
  alert(
    {
      message = '提示内容',
      title = '提示消息',
      width = 420,
      icon = 'error',
      confirmText,
    } = {},
    callback,
  ) {
    QcDialog.alert({
      title,
      message,
      width,
      icon,
      confirmText,
    }).then(() => {
      if (callback) {
        callback();
      }
    });
  },
  confirm(
    {
      message = '提示内容',
      title = '提示消息',
      width = 420,
      icon = 'error',
      confirmText,
      cancelText,
      content,
    } = {},
    callback,
  ) {
    QcDialog.confirm({
      title,
      message,
      width,
      icon,
      confirmText,
      cancelText,
      content,
      closeTriggers: [],
    }).then(confirm => {
      callback(confirm);
    });
  },
};

export default dialog;
